import React from 'react';
import { GridColDef } from '@mui/x-data-grid';
import { FDataGrid } from '../grid';
type Props={rows:any[]; loading?:boolean};
class CADecisionGrid extends React.Component<Props>{
 columns:GridColDef[]=[
  {field:'decisiontype',headerName:'Decision',width:150},
  {field:'decisionscope',headerName:'Scope',width:130},
  {field:'decisiondate',headerName:'Date',width:130},
  {field:'meetingreference',headerName:'Meeting Ref',width:180},
  {field:'observations',headerName:'Observations',flex:1,minWidth:260},
  {field:'remarks',headerName:'Remarks',flex:1,minWidth:220},
 ];
 render(){return <FDataGrid title="CA Decisions" rows={this.props.rows||[]} columns={this.columns} loading={this.props.loading} height={360} showQuickFilter toolbarSx={{backgroundColor:'#e7f6ea'}} getRowId={(r:any)=>r.rid||r.id}/>;}
}
export default CADecisionGrid;
